export const SAMPLE_DIAGRAMS = [
  {
    id: "flowchart-1",
    name: "Basic Flowchart",
    type: "flowchart",
    description: "A simple workflow diagram",
    code: `graph TD
    A[Start] --> B{Is it working?}
    B -->|Yes| C[Great!]
    B -->|No| D[Debug]
    D --> B
    C --> E[End]`,
    tags: ["workflow", "decision", "basic"]
  },
  {
    id: "sequence-1",
    name: "User Authentication",
    type: "sequence",
    description: "User login sequence diagram",
    code: `sequenceDiagram
    participant User
    participant Frontend
    participant Auth
    participant Database
    
    User->>Frontend: Login Request
    Frontend->>Auth: Validate Credentials
    Auth->>Database: Check User
    Database-->>Auth: User Data
    Auth-->>Frontend: JWT Token
    Frontend-->>User: Login Success`,
    tags: ["authentication", "api", "sequence"]
  },
  {
    id: "class-1",
    name: "E-commerce System",
    type: "class",
    description: "Class diagram for online shopping",
    code: `classDiagram
    class Customer {
        +String name
        +String email
        +String address
        +login()
        +logout()
        +placeOrder()
    }
    
    class Order {
        +String orderId
        +Date orderDate
        +Double totalAmount
        +String status
        +calculateTotal()
        +updateStatus()
    }
    
    class Product {
        +String productId
        +String name
        +Double price
        +Integer stock
        +updateStock()
        +getPrice()
    }
    
    Customer ||--o{ Order : places
    Order ||--o{ Product : contains`,
    tags: ["system-design", "object-oriented", "ecommerce"]
  },
  {
    id: "state-1",
    name: "Order Processing",
    type: "state",
    description: "Order state transitions",
    code: `stateDiagram-v2
    [*] --> Created
    Created --> Paid : payment_received
    Created --> Cancelled : cancel_order
    Paid --> Shipped : ship_order
    Shipped --> Delivered : delivery_complete
    Shipped --> Returned : return_request
    Delivered --> [*]
    Cancelled --> [*]
    Returned --> Refunded
    Refunded --> [*]`,
    tags: ["state-machine", "process", "order-management"]
  },
  {
    id: "er-1",
    name: "Blog Database",
    type: "er",
    description: "Entity-relationship diagram for blog system",
    code: `erDiagram
    USER ||--o{ POST : writes
    USER {
        int user_id PK
        string username
        string email
        datetime created_at
    }
    
    POST ||--o{ COMMENT : has
    POST {
        int post_id PK
        string title
        text content
        datetime published_at
        int author_id FK
    }
    
    COMMENT {
        int comment_id PK
        text content
        datetime created_at
        int post_id FK
        int user_id FK
    }
    
    USER ||--o{ COMMENT : makes`,
    tags: ["database", "relationships", "blog"]
  },
  {
    id: "gantt-1",
    name: "Project Timeline",
    type: "gantt",
    description: "Software development project schedule",
    code: `gantt
    title Software Development Project
    dateFormat YYYY-MM-DD
    section Planning
    Requirements Analysis    :req, 2024-01-01, 2024-01-15
    System Design          :design, after req, 10d
    
    section Development
    Backend Development     :backend, 2024-01-20, 30d
    Frontend Development    :frontend, 2024-02-01, 25d
    Integration            :integration, after backend frontend, 10d
    
    section Testing
    Unit Testing           :unit, after backend, 15d
    Integration Testing    :int-test, after integration, 10d
    User Acceptance Testing :uat, after int-test, 5d
    
    section Deployment
    Production Deployment   :deploy, after uat, 3d`,
    tags: ["project-management", "timeline", "development"]
  },
  {
    id: "pie-1",
    name: "Market Share",
    type: "pie",
    description: "Technology market distribution",
    code: `pie title Technology Market Share 2024
    "React" : 35
    "Vue" : 20
    "Angular" : 18
    "Svelte" : 12
    "Others" : 15`,
    tags: ["statistics", "market-analysis", "pie-chart"]
  },
  {
    id: "git-1",
    name: "Git Workflow",
    type: "gitgraph",
    description: "Feature branch workflow",
    code: `gitGraph
    commit
    branch develop
    checkout develop
    commit
    branch feature/login
    checkout feature/login
    commit
    commit
    checkout develop
    merge feature/login
    checkout main
    merge develop
    commit`,
    tags: ["version-control", "workflow", "git"]
  },
  {
    id: "journey-1",
    name: "User Onboarding",
    type: "journey",
    description: "New user experience journey",
    code: `journey
    title User Onboarding Journey
    section Discovery
      Visit Website: 5: User
      Browse Features: 4: User
      Check Pricing: 3: User
    section Registration
      Sign Up: 4: User
      Verify Email: 3: User
      Complete Profile: 4: User
    section First Use
      Tutorial: 5: User
      First Task: 4: User
      Get Help: 3: User
    section Adoption
      Regular Usage: 5: User
      Invite Others: 4: User`,
    tags: ["user-experience", "onboarding", "customer-journey"]
  },
  {
    id: "aws-1",
    name: "AWS Architecture",
    type: "flowchart",
    description: "AWS services architecture example",
    code: `graph TD
    A[User] --> B["Amazon Cognito"]
    B --> C{Authenticated?}
    C -->|Yes| D["JWT Token"]
    C -->|No| E["Login Page"]
    D --> F["API Gateway"]
    F --> G["Lambda Function"]
    G --> H["DynamoDB"]
    G --> I["S3 Bucket"]
    E --> A
    
    classDef aws fill:#FF9900,stroke:#232F3E,stroke-width:2px,color:#fff
    classDef user fill:#4CAF50,stroke:#2E7D32,stroke-width:2px,color:#fff
    classDef data fill:#2196F3,stroke:#1565C0,stroke-width:2px,color:#fff
    
    class B,F,G aws
    class A,E user
    class H,I data`,
    tags: ["aws", "architecture", "cloud"]
  }
];
